module.exports = __webpack_public_path__ + "01ab9214b8351d58e4c7a38ea7693567.png";